import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  TextField,
  Divider,
  Select,
  Button,
  Modal,
  IconButton,
  MenuItem
} from "@mui/material";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import QuickAdd from "../../shared/components/QuickAdd";
import { Box, Stack } from "@mui/system";
import LockIcon from "@mui/icons-material/Lock";
import CachedIcon from "@mui/icons-material/Cached";
import LoginIcon from "@mui/icons-material/Login";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ArticleIcon from "@mui/icons-material/Article";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Close } from "@mui/icons-material";
import PatientPortalAdminLoginActivity from "./PatientPortalAdminLoginActivity";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as actionType from "../actions";
import moment from "moment";
import isAccess from "../../shared/components/CheckUserRights";
import LoadingSpinner from "../../shared/components/LoadingSpinner";
import DeleteModal from "../../shared/components/DeleteModal";

import DeleteIcon from "@mui/icons-material/Delete";
import MessageModal from "../../shared/components/MessageModal";
import ConfirmationModal from "../../shared/components/ConfirmationModal";
import DataGridPremiumComp from "../../shared/components/DataGridPremiumComp";

const PatientPortalAdmin = (props) => {
  const formData = {
    dob: "All",
    patientNameId: "",
    endDate: "",
    startDate: "",
    loginEndDate: "",
    loginStartDate: "",
    lastLogin: "All",
    practiceId: ""
  };
  const {
    patientPortalAdminList = [],
    actions,
    loading,
    resetEmailResponse = [],
    custAuth,
    caLoading,
    success,
    errorMsg,
    profileDetails
  } = props;
  const dobList = ["All", "Custom Range"];
  const lastLoginList = ["All", "Last 7 Days", "Last 30 Days", "This Year", "Custom Range"];
  const [values, setValues] = useState(formData);
  const [openAudit, setOpenAudit] = useState(false);
  const [openManual, setOpenManual] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [pageSize, setPageSize] = useState({
    pageSize: 100,
    page: 0
  });
  const [filteredRows, setFilteredRows] = useState([]);
  const [auditProp, setAuditProp] = useState("");
  const [dropdownDisable, setDropdownDisable] = useState(true);
  const [congnitoUserId, setCongnitoUserId] = useState("");
  const loggedInUserId = localStorage.getItem("cognitoUserId");
  const [deleteModal, setDeleteModal] = useState(false);
  const [patientID, setPatientID] = useState("");
  const [isMessageModal, setIsMessageModal] = useState(false);
  const [isResetPass, setIsResetPass] = useState(false);
  const [passResetParams, setPassResetParams] = useState("");
  const [resetPassMessage, setResetPassMessage] = useState("");
  const [practices, setPractices] = useState([]);
  const navigate = useNavigate();
  console.log(navigate);
  const [pId, setPid] = useState("");

  const date = new Date();
  const currentDate = `${
    date.getMonth() + 1 > 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
  }/${date.getDate()}/${date.getFullYear()}`;

  const last7 = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
  const sevenDaysAgo = `${
    last7.getMonth() + 1 > 10 ? last7.getMonth() + 1 : "0" + (last7.getMonth() + 1)
  }/${last7.getDate()}/${last7.getFullYear()}`;

  const last30 = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
  const thirtyDaysAgo = `${
    last30.getMonth() + 1 > 10 ? last30.getMonth() + 1 : "0" + (last30.getMonth() + 1)
  }/${last30.getDate()}/${last30.getFullYear()}`;

  const last365 = new Date(date.getTime() - 365 * 24 * 60 * 60 * 1000);
  const yearAgo = `${
    last365.getMonth() + 1 > 10 ? last365.getMonth() + 1 : "0" + (last365.getMonth() + 1)
  }/${last365.getDate()}/${last365.getFullYear()}`;
  // console.log(values);
  const handleClose = () => {
    setOpenAudit(false);
    setOpenManual(false);
    setOpenEmail(false);
  };
  useEffect(() => {
    if (patientPortalAdminList.length > 0) {
      setDropdownDisable(false);
    } else {
      setDropdownDisable(true);
    }
  }, [patientPortalAdminList]);

  const handleSearchClick = (e, searchText) => {
    actions.resetPatientPortalAdminList();
    setValues({ ...values, patientNameId: searchText });
  };

  useEffect(() => {
    const payload = values;
    actions.getPatientPortalAdminList(payload);
  }, [values]);

  const handleClearSearch = () => {
    // console.log("handle clear search x!!");
    actions.resetPatientPortalAdminList();
    setDropdownDisable(true);
    setValues(formData);
  };

  const handleIconToggle = (params) => {
    if (params.row.userStatus === "enable") {
      const userStatus = "disable";
      actions.getEnableDisable({ userName: params.row.userName, userStatus: userStatus, values });
    } else {
      const userStatus = "enable";
      actions.getEnableDisable({ userName: params.row.userName, userStatus: userStatus, values });
    }
  };

  const lockIconRenderer = (params) => {
    if (params.row.userStatus === "enable") {
      return (
        <LockOpenIcon
          sx={{ color: "#1BA3AD" }}
          onClick={() => {
            handleIconToggle(params);
          }}
        />
      );
    } else {
      return (
        <LockIcon
          sx={{ color: "#1BA3AD" }}
          onClick={() => {
            handleIconToggle(params);
          }}
        />
      );
    }
  };

  useEffect(() => {
    // console.log(patientPortalAdminList, "patientPortalAdminListpatientPortalAdminList");
    setFilteredRows(
      patientPortalAdminList.map((item, index) => {
        item.id = index;
        return item;
      })
    );
  }, [patientPortalAdminList]);

  const handleResetClick = (params) => {
    setPassResetParams(params);
    setIsResetPass(true);
    let patientName = params?.row?.patientName?.split(",")[0];
    setResetPassMessage(`Are you sure you want to reset the password for ${patientName}?`);
  };

  const handleResetPass = () => {
    const payload = passResetParams.row.userName;
    actions.resetEmail({ payload });
    closeResetPassModal();
  };

  const closeResetPassModal = () => {
    setPassResetParams("");
    setIsResetPass(false);
    setResetPassMessage("");
  };

  const handleLoginClick = (params) => {
    // console.log(params.row, "user data");
    actions.fetchCustAuth({ userName: params.row.userName });
    setCongnitoUserId(params.row.userName);
    // actions.fetchCustAuth({ userName: "83324181-bb06-4a0d-af0f-8ec72353c4be" });
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    const payload = { personId: patientID };
    actions.deleteUsers(payload);
    closeDeleteModal();
  };

  useEffect(() => {
    if (success || errorMsg) {
      setIsMessageModal(true);
      // console.log("Model poped...");
      // console.log(success, errorMsg, "1");
    }
    // console.log(success, errorMsg, "2");
  }, [errorMsg, success]);

  const closeMessageModal = () => {
    // console.log("model closed...");
    setIsMessageModal(false);
    actions.resetMessage();
    const payload = values;
    actions.getPatientPortalAdminList(payload);
  };

  useEffect(() => {
    // console.log(congnitoUserId, caLoading, "congnitoUserId");
    // console.log(custAuth?.cognitoUserId, "custAuth.cognitoUserId");
    // console.log(custAuth, "custAuth.cognitoUserId");
    if (custAuth && custAuth?.idToken && congnitoUserId == custAuth?.cognitoUserId) {
      // console.log(custAuth, "custAuthcustAuthcustAuthcustAuth");
      const custRedirectUrl =
        custAuth?.custRedirectUrl +
        `&login_by=admin&impersonatorId=${loggedInUserId}&congnitoUserId=${congnitoUserId}`;
      // const custRedirectUrl = `http://localhost:3001/#id_token=${custAuth?.idToken}&access_token=${custAuth?.accessToken}&impersonatorId=${loggedInUserId}&login_by=admin&congnitoUserId=${congnitoUserId}`;
      // console.log("custRedirectUrl", custRedirectUrl);
      window.open(custRedirectUrl, "_blank");
      actions.createImpersonateLog({
        impersonatorId: loggedInUserId,
        eventName: "Login In",
        screenName: "Login In",
        eventType: "impersonate",
        ipAddress: "192.168.1.1",
        patientId: congnitoUserId
      });
    }
  }, [caLoading]);

  // http://localhost:3001/#id_token=eyJraWQiOiI1N3p4RzV4cjNCcVwvZ3hDeDY5YkhcLzdza2lTVzdTdE9oVnNwMTlUZ1pLQ1U9IiwiYWxnIjoiUlMyNTYifQ.eyJhdF9oYXNoIjoiR2ttUkxqdG9lOEc1UGhBZFhUemlWQSIsInN1YiI6IjUwZGMzZTRhLTYyNmEtNGFiZi05MDQ0LWZkMjFlMDQwMjBmNyIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTEuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0xX3pZbG1laU5JayIsImNvZ25pdG86dXNlcm5hbWUiOiI1MGRjM2U0YS02MjZhLTRhYmYtOTA0NC1mZDIxZTA0MDIwZjciLCJjdXN0b206cGF0aWVudF9wIjoiOnNyZ3B0cDpwdGhwOmZlOnB5YjpkYzptZTpwZjoiLCJhdWQiOiIxMzRmZ2g4MjZvYmU3M3A2bTY4dHAycmtzOSIsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNzAzNTg1MTA4LCJuYW1lIjoiTWFuaXNoIiwiZXhwIjoxNzAzNTg4NzA4LCJpYXQiOjE3MDM1ODUxMDgsImZhbWlseV9uYW1lIjoiS3VtYXdhdCIsImp0aSI6ImQ0NjEzOTQ2LTQyMTQtNGM5NC1hMDdmLThjZTVkMzYzNDFkNSIsImVtYWlsIjoibWFuaXNoLmJhbG9kaWFAZmV4bGUuY29tIn0.m4DSdout1pzjRWASf57bjmg2IfmutcCFhe_aRq3FHIrHlW-U0CpxqBXRNOyXNUAIo2Pfu0VyD0HQzQZMjMobd83KSfw8VNsUZ-AYjLKR9klJZP-dAJqXTfGtCRh4EQOwSNWng48YQ968J847PpR-LG7MHzYOKP5VYPP2BGKdgs548LLVW8NcnVyvEcsViAcNUuMKlJ3XwzVZ8IXCu5rjPRD_yIY3VkT8FY0gL1kIsR9Z08UwugRIF1WDWZZfmswcf2OYpo9vYYxbWZn0Bt478i-iRSybolAv3MgIpNG5q7xnHb_mlgmbAXtiTiXllLuYLemylsLlDiK681Kn83IL3Q&access_token=eyJraWQiOiJSaVdwb1BQTE5cL2JETmVcL3hXTWliaDUzXC9QUWs5UzVkMVwvR2xFQlpVa0JEWT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI1MGRjM2U0YS02MjZhLTRhYmYtOTA0NC1mZDIxZTA0MDIwZjciLCJ0b2tlbl91c2UiOiJhY2Nlc3MiLCJzY29wZSI6ImF3cy5jb2duaXRvLnNpZ25pbi51c2VyLmFkbWluIG9wZW5pZCBwcm9maWxlIiwiYXV0aF90aW1lIjoxNzAzNTg1MTA4LCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV96WWxtZWlOSWsiLCJleHAiOjE3MDM1ODg3MDgsImlhdCI6MTcwMzU4NTEwOCwidmVyc2lvbiI6MiwianRpIjoiZGQ4NzM3YmYtZThjOC00MWIyLTgyZDItZmQ0Mjk4MTI3NmRlIiwiY2xpZW50X2lkIjoiMTM0ZmdoODI2b2JlNzNwNm02OHRwMnJrczkiLCJ1c2VybmFtZSI6IjUwZGMzZTRhLTYyNmEtNGFiZi05MDQ0LWZkMjFlMDQwMjBmNyJ9.5nJ0M9X3WmPO6vdKdJz04KnEBGserElcP_JVI3teW-QeMx_GVXKONeMTuOgxgvNVHHPEcIoI6QGvlQotKIDHV-pLUa6xL0AS1z-lh6Ad6aDJOUNxbIDiCJsLuI4twKQcyDkRLdav1X4MG7IuhmHoLd9DiPqHgKrvKamv-IzoYiLWJWsbpZW7NByrKh9xV_vHCavSmSfpTCuouNQhPFqvyjitGgMiB4OvfznQbjOwKomEzLaQCCoy7E3AU3jZbIav_RTOmxSsdFQMop5WdzrRJW8D0Ih3J8e9YUdNn9SoepA_GiN2C2WdhQi8BK8zK19KTERTfOMlGU7A4NS1tDrViA&expires_in=3600&token_type=Bearer

  useEffect(() => {
    if (resetEmailResponse.length > 0) {
      setOpenEmail(true);
    }
  }, [resetEmailResponse]);

  const renderResetIcon = (params) => {
    return <CachedIcon sx={{ color: "#1BA3AD" }} onClick={() => handleResetClick(params)} />;
  };

  const renderLoginIcon = (params) => {
    return (
      <LoginIcon
        sx={{ color: "#1BA3AD", cursor: "pointer" }}
        onClick={() => handleLoginClick(params)}
      />
    );
  };

  // console.log(filteredRows, "filteredRowsfilteredRows");

  const rows = filteredRows.map((item, index) => {
    item.id = index;
    return item;
  });

  const resetAll = () => {
    setValues({
      dob: "All",
      patientNameId: values.patientNameId,
      endDate: "",
      startDate: "",
      loginEndDate: "",
      loginStartDate: "",
      lastLogin: "All"
    });
  };

  const columns = [
    {
      field: "patientName",
      headerName: "PATIENT",
      width: 230,
      editable: false
    },
    {
      field: "enableDisable",
      headerName: "ENABLE / DISABLE",
      width: 80,
      editable: false,
      renderCell: (params) => lockIconRenderer(params)
    },
    {
      field: "resetPassword",
      headerName: "RESET PASSWORD",
      width: 80,
      editable: false,
      renderCell: (params) => renderResetIcon(params)
    },
    {
      field: "impersonate",
      headerName: "IMPERSONATE",
      width: 120,
      editable: false,
      renderCell: (params) => renderLoginIcon(params)
    },
    {
      field: "auditLogs",
      headerName: "AUDIT LOGS",
      width: 79,
      editable: false,
      renderCell: ({ row }) => {
        return (
          <Button
            onClick={() => {
              setOpenAudit(true);
              setAuditProp(row.patientEmail);
            }}>
            <ArticleIcon />
          </Button>
        );
      }
    },

    // {
    //   field: "userLogin",
    //   headerName: "LOGIN TO PATIENT PORTAL",
    //   width: 80,
    //   editable: false,
    //   renderCell: ({ row }) => {
    //     return row.userStatus === "enable" ? (
    //       <PersonOutlineIcon
    //         sx={{ color: "#00acc8" }}
    //         onClick={() =>
    //           window.open(`https://d29s3ndany2t3o.cloudfront.net/${row.patientEmail}`, "_blank")
    //         }
    //       />
    //     ) : (
    //       <PersonOutlineIcon sx={{ color: "lightGrey" }} disabled />
    //     );
    //   }
    // },
    {
      field: "dateOfBirth",
      headerName: "DOB",
      width: 100,
      editable: false
    },
    // {
    //   field: "userName",
    //   headerName: "USERNAME",
    //   width: 190,
    //   editable: false
    // },
    {
      field: "patientEmail",
      headerName: "EMAIL ADDRESS",
      width: 280,
      editable: false
    },
    {
      field: "lastLogin",
      headerName: "LAST LOGIN",
      width: 100,
      editable: false,
      renderCell: ({ row }) => {
        return row.lastLogin === null || "" ? "-" : row.lastLogin.replaceAll("-", "/");
      }
    },
    {
      field: "id",
      headerName: "Delete",
      width: 79,
      editable: false,
      hide: isAccess("ptdle") ? false : true,
      renderCell: ({ row }) => {
        //console.log("row", row);
        return (
          <IconButton
            onClick={() => {
              setDeleteModal(true);
              setPatientID(row.patientId);
            }}>
            <DeleteIcon color={"primary"}></DeleteIcon>
          </IconButton>
        );
      }
    }
  ];

  useEffect(() => {
    setPractices(profileDetails["practiceList"]);

    let locaStoragePracticeId = localStorage.getItem("practiceId");
    let practiceId = "";

    if (locaStoragePracticeId !== "undefined" && locaStoragePracticeId !== null) {
      practiceId = locaStoragePracticeId;
    } else {
      practiceId = profileDetails["defaultPracticeId"];
    }

    setPid(practiceId);
  }, [profileDetails]);

  useEffect(() => {
    if (pId !== "" && pId !== undefined) {
      console.log("zhr inside pId", pId);
      setValues({ ...values, practiceId: pId });
    }
  }, [pId]);

  const handlePracticeChange = (e) => {
    setPid(e.target.value);
    setValues({ ...values, practiceId: e.target.value });
  };

  return (
    <>
      {(isAccess("ptpla") || isAccess("ucron")) && (
        <div className={`${loading ? "disable-section" : ""}`}>
          {caLoading && <LoadingSpinner />}
          <Box className="align-center pad-5 teal-bg-color m-l-5 directory-container">
            <Grid container>
              <Grid item xs={10}>
                <QuickAdd
                  isOnlyUserId={true}
                  text={1.3}
                  search={6}
                  handleSearchClick={handleSearchClick}
                  clearSearchClick={handleClearSearch}
                  // getSearchText={getSearchText}
                />
              </Grid>
            </Grid>

            <Grid container className="align-center mt-10">
              <Grid item xs={1.3}>
                <Typography>Practice</Typography>
              </Grid>
              <Grid item xs={3}>
                <Select
                  fullWidth
                  name="pid"
                  id="pid"
                  value={pId}
                  xs={5}
                  onChange={(e) => handlePracticeChange(e)}>
                  {practices?.map((item, index) => {
                    return (
                      <MenuItem value={item.practiceId} key={index}>
                        {item.practiceName} - {item.practiceId}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
            </Grid>

            <Grid container className="align-center mt-10">
              <Grid item xs={1.3}>
                <Typography>DOB</Typography>
              </Grid>
              <Grid item xs={3}>
                <Select
                  disabled={dropdownDisable}
                  fullWidth
                  name="dob"
                  value={values.dob}
                  onChange={(e) => {
                    if (e.target.value !== "Custom Range") {
                      setValues({
                        ...values,
                        dob: e.target.value,
                        startDate: "",
                        endDate: ""
                      });
                    } else {
                      setValues({ ...values, dob: e.target.value });
                    }
                  }}
                  className="stage-practice-dropdown">
                  {dobList.map((item, index) => {
                    return (
                      <MenuItem value={item} key={index}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              {values.dob === "Custom Range" ? (
                <>
                  <Grid item xs={1}>
                    <Typography sx={{ ml: 1 }}>From</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        disabled={dropdownDisable}
                        disableFuture
                        openTo="day"
                        value={values.startDate}
                        onChange={(newValue) => {
                          setValues({
                            ...values,
                            startDate: moment(new Date(newValue)).format("MM/DD/YYYY")
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth />
                        )}></DatePicker>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography sx={{ ml: 1 }}> To</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        disabled={dropdownDisable}
                        disableFuture
                        openTo="day"
                        value={values.endDate}
                        onChange={(newValue) => {
                          setValues({
                            ...values,
                            endDate: moment(new Date(newValue)).format("MM/DD/YYYY")
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth />
                        )}></DatePicker>
                    </LocalizationProvider>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>

            <Grid container className="align-center mt-10">
              <Grid container className="align-center">
                <Grid item xs={1.3}>
                  <Typography>Last Login</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    disabled={dropdownDisable}
                    fullWidth
                    name="lastLogin"
                    value={values.lastLogin}
                    onChange={(e) => {
                      if (e.target.value === "Last 7 Days") {
                        setValues({
                          ...values,
                          lastLogin: e.target.value,
                          loginStartDate: sevenDaysAgo,
                          loginEndDate: currentDate
                        });
                      } else if (e.target.value === "Last 30 Days") {
                        setValues({
                          ...values,
                          lastLogin: e.target.value,
                          loginStartDate: thirtyDaysAgo,
                          loginEndDate: currentDate
                        });
                      } else if (e.target.value === "This Year") {
                        setValues({
                          ...values,
                          lastLogin: e.target.value,
                          loginStartDate: yearAgo,
                          loginEndDate: currentDate
                        });
                      } else {
                        setValues({
                          ...values,
                          lastLogin: e.target.value,
                          loginStartDate: "",
                          loginEndDate: ""
                        });
                      }
                    }}
                    className="stage-practice-dropdown">
                    {lastLoginList.map((item, index) => {
                      return (
                        <MenuItem value={item} key={index}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
                {values.lastLogin === "Custom Range" ? (
                  <>
                    <Grid item xs={1.18}>
                      <Typography sx={{ ml: 1 }}>From</Typography>
                    </Grid>
                    <Grid item xs={2.33}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          disabled={dropdownDisable}
                          disableFuture
                          openTo="day"
                          value={values.loginStartDate}
                          onChange={(newValue) => {
                            setValues({
                              ...values,
                              loginStartDate: moment(new Date(newValue)).format("MM/DD/YYYY")
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                          )}></DatePicker>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={1.18}>
                      <Typography sx={{ ml: 1 }}> To</Typography>
                    </Grid>
                    <Grid item xs={2.33}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          disabled={dropdownDisable}
                          disableFuture
                          openTo="day"
                          value={values.loginEndDate}
                          onChange={(newValue) => {
                            setValues({
                              ...values,
                              loginEndDate: moment(new Date(newValue)).format("MM/DD/YYYY")
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                          )}></DatePicker>
                      </LocalizationProvider>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
                <Grid item xs={2} className="align-center m-l-20 mt-10 ">
                  {values.dob !== "All" || values.lastLogin !== "All" ? (
                    <Typography className="cursor-pointer" color="primary" onClick={resetAll}>
                      Reset All
                    </Typography>
                  ) : (
                    <Typography className="cursor-pointer" sx={{ color: "lightGrey" }} disabled>
                      Reset All
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box className="grid-style" sx={{ height: "660px" }}>
            <Stack direction="row" className="grid-header">
              <Typography sx={{ marginLeft: "5px", marginBottom: "15px" }}>
                {filteredRows.length} patients matching your criteria
              </Typography>
            </Stack>
            <DataGridPremiumComp
              rows={rows}
              rowCount={rows.length}
              columns={columns}
              loading={loading}
              pageSizeOptions={[10, 25, 50, 100]}
              pageSize={pageSize.pageSize}
              paginationModel={pageSize}
              onPaginationModelChange={(newPageSize) => setPageSize(newPageSize)}
              pagination
            />
          </Box>
          <Modal
            open={openAudit}
            onClose={handleClose}
            aria-labelledby="modal-add-title"
            aria-describedby="modal-add-description">
            <Box
              className="modal-style-contact"
              style={{ maxHeight: "65vh", overflow: "auto" }}
              sx={{ width: "800px" }}>
              <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h2">AUDIT LOGS FOR {auditProp}</Typography>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Stack>
              <Divider sx={{ backgroundColor: "#177483" }} orientation="horizontal" />
              <Stack sx={{ marginTop: "15px", marginBottom: "5px" }}>
                <Grid item xs={12} container className="modal-stackMedCase">
                  <Grid item xs={11}>
                    <Box flexDirection="row">
                      <PatientPortalAdminLoginActivity email={auditProp} />
                    </Box>
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                sx={{ my: 3, alignItems: "center", justifyContent: "flex-end" }}>
                <Button variant="contained" className="btn-primary" onClick={handleClose}>
                  CANCEL
                </Button>
              </Stack>
            </Box>
          </Modal>
          <Modal
            open={openManual}
            onClose={handleClose}
            aria-labelledby="modal-add-title"
            aria-describedby="modal-add-description">
            <Box
              className="modal-style-contact"
              style={{ maxHeight: "70vh", overflow: "auto" }}
              sx={{ width: "500px" }}>
              <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h2">Redirect to Patient Information</Typography>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Stack>
              <Divider sx={{ backgroundColor: "#177483" }} orientation="horizontal" />
              <Stack sx={{ marginTop: "15px", marginBottom: "5px" }}>
                <Grid item xs={12} container className="modal-stackMedCase">
                  <Grid item xs={11}>
                    <Typography>HyperLink</Typography>
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                sx={{ my: 3, alignItems: "center", justifyContent: "flex-end" }}>
                <Button variant="contained" className="btn-primary" onClick={handleClose}>
                  CANCEL
                </Button>
                <Button variant="contained" className="btn-primary">
                  OPEN MANUALLY
                </Button>
              </Stack>
            </Box>
          </Modal>
          <Modal
            open={openEmail}
            onClose={handleClose}
            aria-labelledby="modal-add-title"
            aria-describedby="modal-add-description">
            <Box
              className="modal-style-contact"
              style={{ maxHeight: "70vh", overflow: "auto" }}
              sx={{ width: "500px" }}>
              <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h2">Reset Email</Typography>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Stack>
              <Divider sx={{ backgroundColor: "#177483" }} orientation="horizontal" />
              <Stack sx={{ marginTop: "15px", marginBottom: "5px" }}>
                <Grid item xs={12} container className="modal-stackMedCase">
                  <Grid item xs={11}>
                    <Typography>{resetEmailResponse}</Typography>
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                sx={{ my: 3, alignItems: "center", justifyContent: "flex-end" }}>
                <Button variant="contained" className="btn-primary" onClick={handleClose}>
                  OK
                </Button>
              </Stack>
            </Box>
          </Modal>

          <DeleteModal
            open={deleteModal}
            id={patientID}
            handleDelete={handleDelete}
            close={closeDeleteModal}
          />

          <MessageModal
            open={isMessageModal}
            message={success}
            error={errorMsg}
            closeModal={closeMessageModal}
          />

          <ConfirmationModal
            open={isResetPass}
            close={closeResetPassModal}
            handleOpeartion={handleResetPass}
            message={resetPassMessage}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({
  patientPortalAdminReducer,
  auditLogsReducer,
  enableDisableReducer,
  resetEmailReducer,
  userReducer,
  profileDrawerReducer
}) => {
  return {
    patientPortalAdminList: patientPortalAdminReducer.patientPortalAdminList,
    loading: patientPortalAdminReducer.loading,
    auditLogs: auditLogsReducer.auditLogs,
    auditLogsLoading: auditLogsReducer.loading,
    enableResponse: enableDisableReducer.enableResponse,
    resetEmailResponse: resetEmailReducer.resetEmailResponse,
    error: resetEmailReducer.error,
    caLoading: userReducer.caLoading,
    custAuth: userReducer.custAuth,
    success: patientPortalAdminReducer.success,
    errorMsg: patientPortalAdminReducer.error,
    profileDetails: profileDrawerReducer.profileDetails
  };
};
const mapDispatchToProps = (dispatch) => ({
  actions: {
    getPatientPortalAdminList: (payload) => {
      dispatch(actionType.getPatientPortalAdminList(payload));
    },
    getEnableDisable: (payload) => {
      dispatch(actionType.getEnableDisable(payload));
    },
    resetPatientPortalAdminList: () => {
      dispatch(actionType.resetPatientPortalAdminList());
    },
    resetEmail: (payload) => {
      dispatch(actionType.resetEmail(payload));
    },
    fetchCustAuth: (payload) => {
      dispatch(actionType.fetchCustAuth(payload));
    },
    createImpersonateLog: (payload) => {
      dispatch(actionType.createImpersonateLog(payload));
    },
    deleteUsers: (payload) => {
      dispatch(actionType.deleteUsers(payload));
    },
    resetMessage: () => {
      dispatch(actionType.deleteUserResetMessage());
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientPortalAdmin);
